import { render, staticRenderFns } from "./ResultDetail.vue?vue&type=template&id=9e3f4fca&"
import script from "./ResultDetail.vue?vue&type=script&lang=js&"
export * from "./ResultDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResultDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports